import axios from 'axios'
import { BUSCAR_ULTIMOS_HISTORICOS_ITINERARIO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarUltimosHistoricosItinerario (itinerarioId, empresaId) {
  let url = `${URL}/itinerario/${itinerarioId}/empresa/${empresaId}/historicos`;
  
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_ULTIMOS_HISTORICOS_ITINERARIO,
        payload: response

      })
  );
}
